export default __webpack_public_path__ + "static/media/gallery - spells_07.1ff7580a.jpg";